import { render, staticRenderFns } from "./MasieroLogo.vue?vue&type=template&id=fa755576&scoped=true&"
var script = {}
import style0 from "./MasieroLogo.vue?vue&type=style&index=0&id=fa755576&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa755576",
  null
  
)

export default component.exports